export const courses = [
  {
    id: 1,
    title: "Klasični Beli Hleb",
    videoUrl: "https://www.youtube.com/embed/8fca4Of6lkw",
    youtubeId: "8fca4Of6lkw",
    duration: "15:30",
    description: "Naučite kako pravilno mesiti testo i peći savršen beli hleb sa parom",
    thumbnail: "https://img.youtube.com/vi/8fca4Of6lkw/hqdefault.jpg"
  },
  {
    id: 2,
    title: "Kiflice od Kvasca sa Sirom",
    videoUrl: "https://www.youtube.com/embed/01S7av-XGmw",
    youtubeId: "01S7av-XGmw",
    duration: "12:45",
    description: "Detaljne upustva za pravljenje mekanih kiflica sa ukusnim sirom",
    thumbnail: "https://img.youtube.com/vi/01S7av-XGmw/hqdefault.jpg"
  },
  {
    id: 3,
    title: "Srpska Pogača",
    videoUrl: "https://www.youtube.com/embed/i359qnPXBXI",
    youtubeId: "i359qnPXBXI",
    duration: "18:20",
    description: "Autentična srpska pogača sa maslacem i ukusnom strukturom - tradicionalno pekovo",
    thumbnail: "https://img.youtube.com/vi/i359qnPXBXI/hqdefault.jpg"
  },
  {
    id: 4,
    title: "Čokoladne Kiflice",
    videoUrl: "https://www.youtube.com/embed/Y9gnBhd2vwo",
    youtubeId: "Y9gnBhd2vwo",
    duration: "14:15",
    description: "Slatke i mekane čokoladne kiflice koje su savršene za doručak",
    thumbnail: "https://img.youtube.com/vi/Y9gnBhd2vwo/hqdefault.jpg"
  },
  {
    id: 5,
    title: "Medena Baklava",
    videoUrl: "https://www.youtube.com/embed/pNgcr6co6SA",
    youtubeId: "pNgcr6co6SA",
    duration: "22:10",
    description: "Orientalni desert sa filom, orasima i medom - klasična poslastica",
    thumbnail: "https://img.youtube.com/vi/pNgcr6co6SA/hqdefault.jpg"
  }
];
